import Button from '../ui/Button.jsx';
import { Card, CardBody } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const PcLogin = ({ subheading, pcImg, heading, button, text, fn }) => {
    return (
        <div className="component-pc">
            <div className="row">
                <HeadingOne className="col" heading={heading} />
            </div>
            <div className="row justify-center">
                <div className="col xl:w-10/12">
                    <Card>
                        <CardBody>
                            <h2 className="text-center text-2xl">{subheading}</h2>

                            <div className="relative flex items-center justify-center">
                                {/* Obal pro monitor */}
                                <div className="relative aspect-[4/3] w-[600px] md:w-[900px] lg:w-[1200px]">
                                    <img src={pcImg} alt="Monitor" className="h-full w-full object-contain" />
                                    <div className="absolute top-[22%] left-[36%] flex h-[70%] w-[30%] flex-col gap-4">
                                        <div className="pb-5 text-center font-bold">
                                            <div dangerouslySetInnerHTML={{ __html: text }}></div>
                                        </div>
                                        <label htmlFor="username" className="w-full text-left text-lg">
                                            Uživatelské jméno
                                        </label>
                                        <input
                                            id="username"
                                            type="text"
                                            defaultValue="Alfa.Sef"
                                            autoComplete="off"
                                            // readOnly
                                            className="w-full rounded-[40px] border-4 border-[#BAE6FD99] bg-white px-4 py-2 text-lg text-sky-700"
                                        />

                                        <label htmlFor="password" className="w-full text-left text-lg">
                                            Heslo
                                        </label>
                                        <input
                                            id="password"
                                            type="password"
                                            autoComplete="off"
                                            defaultValue="password"
                                            // readOnly
                                            className="w-full rounded-[40px] border border-sky-400 bg-white px-4 py-2 text-sky-700"
                                        />
                                        <div className="flex justify-end pt-4">
                                            {button && <Button {...button} onClick={() => fn.handleAction(button.action)} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default PcLogin;
